export default function calculateReadingTime(data) {
  let allText = data.introText
  data.content.map(({ text }) => (allText += text))
  const words = allText.split(' ')
  const minutes = Math.round(words.length / 200)
  return Math.max(1, minutes)
}
